class Throttle {
    busy = false;
    timer: NodeJS.Timeout | undefined;
    times = 0;

    wait(wait = 1000): Throttle {
        this.times = wait;
        return this;
    }

    do(fn: () => void) {
        if (this.busy) return;
        this.busy = true;
        fn();
        this.timer = setTimeout(() => {
            this.busy = false;
        }, this.times);
    }
}

export const throttle = new Throttle();
